import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import Drawer from '@material-ui/core/Drawer';
import Menu from '@material-ui/icons/Menu';
import EmailRounded from '@material-ui/icons/EmailRounded';
import DividerLine from './dividerLine';
import Button from '@material-ui/core/Button';

import wpStyles from '../../wordpressStyles';

const EventNav = ({ ...props }) => {
    const [opened, setOpened] = useState(false);

    console.log(props.data);

    const toggleDrawer = open => event => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        

        setOpened(open);
    };

    const initals = (firstName, lastName) => {
        firstName = firstName === '' ? ' ' : firstName;
        lastName = lastName === '' ? ' ' : lastName;
        return firstName.split('')[0] + '' + lastName.split('')[0];
    };
    const email = props.data.event.support_email
        ? `mailto:${props.data.event.support_email}?subject=${props.data.event.support_subject}`
        : '';

        

    const navItems = props.data.navigation.map((item, i) => {
        
        return item.react ? (
            <Link
                key={i}
                to={"/" + item.route.path}
                onClick={toggleDrawer(false)}
                className="flex w-full items-center py-3 lg:py-0 mx-0 px-3 lg:mx-2 text-red-500 font-bold"
            >
                {item.route.title}
            </Link>
        ) : (
            <a
                key={i}
                href={item.link.url}
                onClick={toggleDrawer(false)}
                className="flex items-center py-3 lg:py-0 mx-0 px-3 lg:mx-2 text-red-500 font-bold"
                target={item.link.target}
            >
                {item.link.title}
            </a>
        );
       
    });
    

    const list = () => (
        <div className="flex flex-col lg:flex-row lg:flex lg:flex-1 w-48 lg:w-full">
            <div className="flex flex-col lg:flex-row  lg:flex-1 justify-center lg:items-center ">
     
                <div className="flex lg:hidden items-center w-full justify-center py-3 shadow-lg">
                    <div
                        className="flex rounded-full overflow-hidden mx-3 bg-red-500 justify-center items-center"
                        style={{ width: 52, height: 52, ...wpStyles.backgroundColor1 }}
                    >
                        <span className="font-sans text-3x text-white font-bold">
                            {initals(props.data.attendee.first_name, props.data.attendee.last_name)}
                        </span>
                    </div>
                </div>
                
                {/* If showLinks is false, had the nav items */}
                { props.showLinks ? 
                    (<div className="flex flex-wrap lg:flex-no-wrap">
                    <Link to="/"  className="flex w-full items-center py-3 lg:py-0 mx-0 px-3 lg:mx-2 text-red-500 font-bold">Home</Link>    
                        {navItems}
                        
                        {/*props.data.attendee.title == "Staff" && (
                            <Link
                                to="/regionChange"
                                onClick={toggleDrawer(false)}
                                className="flex items-center py-3 lg:py-0 mx-0 px-3 lg:mx-2 text-red-500 font-bold"
                            >
                                Change Area Support Team
                            </Link>
                        )*/}
                    </div>)
                    : ''
                }   
            </div>

            <div className="flex flex-col lg:flex-row lg:flex-initial lg:items-center justify-end">
                <div className="hidden lg:flex items-center w-full justify-center pt-4 lg:pt-0">
                    <div
                        className="flex rounded-full overflow-hidden mx-3 bg-red-500 justify-center items-center"
                        style={{ width: 52, height: 52, ...wpStyles.backgroundColor1 }}
                    >
                        <span className="font-sans text-3x text-white font-bold">
                            {initals(props.data.attendee.first_name, props.data.attendee.last_name)}
                        </span>
                    </div>
                </div>
                <span className="hidden lg:flex font-bold text-gray-700">
                    {props.data.attendee.first_name}&nbsp;{props.data.attendee.last_name}
                </span>
                <DividerLine
                    styles={{
                        margin: '0px 14px',
                        height: '100%',
                        maxHeight: '42px'
                    }}
                />
                <a
                    href={props.data.wordpress.logout.replace('&amp;', '&')}
                    className="flex items-center  py-3 lg:py-0 mx-0 px-3 lg:mx-2 text-red-500 font-bold"
                    style={wpStyles.textColor1}
                >
                    Logout
                </a>
                {email != '' && (
                    <a
                        target="_blank"
                        className="flex items-center  py-3 lg:py-0 mx-0 px-3 lg:mx-2 text-gray-600 font-bold"
                        href={email}
                    >
                        Support
                    </a>
                )}
            </div>
        </div>
    );


    const logos = () => {
        return(<div className="flex flex-initial items-center">
            
            {//Primary Logo
            (props.data.event.event_assets.primary_logo.url || props.data.theme.logo_primary.url) 
            ?
                <Link to="/">
                    <img src={ props.data.event.event_assets.primary_logo.url || props.data.theme.logo_primary.url } className="self-center" style={{maxHeight: '52px'}} alt="Primary Logo" />
                </Link>
                :
                ''
            }
            
            {//Dividing Line
                (props.data.event.event_assets.secondary_logo.url || props.data.theme.logo_secondary.url) 
                ?
                <DividerLine
                    styles={{
                        margin: '0px 20px',
                        height: '100%',
                        maxHeight: '42px'
                    }}
                />
                :
                ''
            }

            {//Secondary Logo
                (props.data.event.event_assets.secondary_logo.url || props.data.theme.logo_secondary.url) 
                ?
                <img src={ props.data.event.event_assets.secondary_logo.url || props.data.theme.logo_secondary.url } className="self-center" style={{maxHeight: '52px'}} alt="Secondary Logo" />
                :
                ''
            }
            
        </div>)
    }

    return (
        

        <div id="event-nav" className="flex py-3 px-3 lg:px-8 justify-between lg:justify-start">
            {logos()}
            
            <div className="flex lg:hidden items-center justify-center">
                <Button onClick={toggleDrawer(true)} className="flex justify-self-end">
                    <Menu />
                </Button>
            </div>
            <Drawer anchor="right" open={opened} onClose={toggleDrawer(false)}>
                {list()}
            </Drawer>
            <div className="hidden flex-col lg:flex-row lg:flex lg:flex-1">{list()}</div>
        </div>
    );
};
export default EventNav;
